<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
          </ion-menu-toggle>
        </ion-buttons>
        <ion-title>{{ yacht_name }}</ion-title>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="$router.push('/home')">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="0"></bg>
      <!-- {{ $store.state }} -->
      <ion-grid>
        <headerlogo></headerlogo>
        <ion-row v-if="yacht_id">
          <ion-col size="12">
            <div class="btn-squared-wrapper">
              <ion-button class="btn-squared" @click="$router.push('/new-yacht/specifications/' + yacht_id);"><img src="../assets/svg/icon-specifications.svg"></ion-button>
              <div class="btn-squared-label">Specification</div>
            </div>
            <div class="btn-squared-wrapper">
              <ion-button class="btn-squared" @click="$router.push('/report/' + yacht_id);"><img src="../assets/svg/icon-list.svg"></ion-button>
              <div class="btn-squared-label">Create report</div>
            </div>
            <div class="btn-squared-wrapper">
              <ion-button class="btn-squared btn-squared-disabled">
                <!-- <img src="../assets/svg/icon-plus.svg"> -->
              </ion-button>
              <div class="btn-squared-label">Create Worklist</div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
export default {
  name: "NewYacht",
  data: function() {
    return {
      yacht_name: '',
      yacht_id: '',
      loader: false
    }
  },
  methods: {
    insert() {
      return this.$ionic.alertController
      .create({
        header: 'New yacht',
        inputs: [
          {
            name: 'yacht_name',
            id: 'yacht_name',
            placeholder: 'Yacht name',
          },
        ],
        buttons: [
          {
            text: 'Back',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              this.$router.back()
            },
          },
          {
            text: 'Insert',
            handler: async() => {
              let name = document.getElementById('yacht_name').value;
              if(name) {
                this.loader = true;
                axios.post(this.apiUrl + '/api/v1/new-yacht', { api_token: this.$store.state.api_token, yacht_name: name })
                .then(async(response) => {
                  let res = response.data
                  if(res.data) {
                    this.yacht_name = res.data.name
                    this.yacht_id = res.data.id
                    const toast = await this.$ionic.toastController.create({
                      message: 'Yacht added succesfully',
                      color: 'success',
                      position: 'bottom',
                      duration: 2000
                    })
                    await toast.present();
                  }
                  this.loader = false;
                })
              } else {
                const toast = await this.$ionic.toastController.create({
                  message: 'Yacht name is required',
                  color: 'danger',
                  position: 'bottom',
                  duration: 3000
                })
                await toast.present();
                this.insert()
              }
            },
          },
        ],
      })
      .then(a => a.present())
    }
  },
  mounted: function() {
    if(this.$route.params.yacht_name) {
      this.yacht_name = this.$route.params.yacht_name;
    }
    if(this.$route.params.yacht_id) {
      this.yacht_id = this.$route.params.yacht_id;
    }

    if(!this.yacht_id) {
      this.insert();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>